module.exports = __webpack_public_path__ + "img/green.adbe10b8.png";